module.exports = __webpack_public_path__ + "6a606c10835bb7d17e86fa694a2ca443.svg";